import React, { useEffect, useState } from "react";
import actionApi from "services/actionApi";
import useAppStore from "store/useAppStore";
import tokenManager from "utils/token";

const AuthContext = React.createContext(null);

export const AuthProvider = ({ children }) => {
  const { setToken, clearToken, getToken, getTokenPayload, isTokenExist } =
    tokenManager();
  const { setName } = useAppStore();

  const [isLoadAuth, setIsLoadAuth] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const isKeepLogin = async () => {
      if (isTokenExist()) {
        await actionApi
          .verifyToken()
          .then(() => {
            setIsAuth(true);
          })
          .catch(() => {
            clearToken();
            setIsAuth(false);
          })
          .finally(() => {
            setIsLoadAuth(false);
          });
      }
      setIsLoadAuth(false);
    };
    isKeepLogin();
  }, []);

  useEffect(() => {}, [isAuth]);

  const doLogin = (token) => {
    setToken(token);
    setName(getTokenPayload()?.name);
    setIsAuth(true);
  };

  const doLogout = () => {
    actionApi.logout().finally(() => {
      clearToken();
      setIsAuth(false);
    });
  };

  const value = {
    doLogin,
    doLogout,
    isAuth,
    isLoadAuth,
    getToken,
    getTokenPayload,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within a AuthProvider");
  }
  return context;
};

export default useAuth;
